export const IDENTIFY_FORM_INITIAL_VALUES = {
  email: '',
} as const;
